<template>
  <div class="child-goal select-list-item" :data-goal-id="goal.id">
    <div class="goal-details text-normal">
      <div class="d-flex goal justify-content-between align-items-center">
        <div class="d-flex align-items-center overflow-hidden pr-2" :title="goal.title">
          <i class="goal-icon flex-shrink-0"></i>
          <span class="pl-2 bold text-truncate" :title="goal.title" v-no-capture>{{
            goal.title
          }}</span>
        </div>
      </div>
    </div>
    <div>
      <template v-for="kr in keyResults">
        <move-initiative-kr-row :kr="kr" :key="kr.id" @move="$emit('move', $event)" />
      </template>
      <div v-if="keyResults.length === 0" class="px-3 pt-3 ml-2 text-small">
        No KRs available
      </div>
    </div>
  </div>
</template>

<script>
import MoveInitiativeKrRow from '@/components/initiative/MoveInitiativeKrRow'
import * as R from 'ramda'

/**
 * This component which show goal and its KRs
 * On hover of KR, option to move to the particular KR is shows
 *
 * Props:
 * - goal
 @emits
 - @move - This is emitted when "Move here" button is clicked
 */
export default {
  name: 'MoveInitiativeGoalViewer',
  props: ['goal'],
  components: {
    MoveInitiativeKrRow
  },
  computed: {
    team() {
      return this.$store.getters.teamById(this.goal.teamId)
    },
    keyResults() {
      return R.propOr([], 'keyResults', this.goal).filter(kr => !kr.isArchived)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.child-goal .goal-details {
  padding-bottom: 4px;
}

.goal {
  padding: 18px 8px 0 0;
}
</style>
